import {
  IGetPlatformMetricsResponse,
  ICapturePlatformMetricsResponse,
} from "common247";
import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";

/**
 * Fetches the current or cached platform metrics snapshot.
 *
 * @param {FirebaseServices} fb - Initialized Firebase client services.
 * @returns {Promise<IGetPlatformMetricsResponse>} Cached or newly generated platform metrics.
 */
export async function getPlatformMetrics(
  fb: FirebaseServices
): Promise<IGetPlatformMetricsResponse> {
  const result = await callFunction<{}, IGetPlatformMetricsResponse>(
    fb,
    "getPlatformMetricsFunc",
    {}
  );
  return result;
}

/**
 * Executes a full recalculation of platform metrics across all collections and emits updated logs.
 *
 * @param {FirebaseServices} fb - Initialized Firebase client services.
 * @returns {Promise<ICapturePlatformMetricsResponse>} Newly calculated platform metrics.
 */
export async function capturePlatformMetrics(
  fb: FirebaseServices
): Promise<ICapturePlatformMetricsResponse> {
  const result = await callFunction<{}, ICapturePlatformMetricsResponse>(
    fb,
    "capturePlatformMetricsFunc",
    {}
  );
  return result;
}
